module.exports = __webpack_public_path__ + "static/media/OpenSea.784e1f37.png";